import React from 'react';
import { Form, Button, Row, Col, Input, Select } from 'antd';

const { Option } = Select;

const FormFilter = ({ form: { getFieldDecorator, validateFields, resetFields }, onSearch }) => {
  const itemLayout = {
    md: 8,
    sm: 12,
  };
  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 7 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 17 },
    },
  };
  const handleSearch = (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      if (!err) {
        onSearch(values);
      }
    });
  };
  const handleReset = (e) => {
    e.preventDefault();
    resetFields();
    onSearch();
  };
  return (
    <Form onSubmit={handleSearch}>
      <Row gutter={32}>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Email">
            {getFieldDecorator('email', {
              initialValue: '',
            })(<Input placeholder='Nhập email' />)}
          </Form.Item>
        </Col>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Role">
            {getFieldDecorator('role', {
              initialValue: [],
            })(<Select optionFilterProp="children" showSearch filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            } placeholder='Chọn Role'>
              <Option value="member">Member</Option>
              <Option value="line-manager">Line Manager</Option>
            </Select>)}
          </Form.Item>
        </Col>
        <Col {...itemLayout}>
          <Form.Item {...formItemLayout} label="Line Manager">
            {getFieldDecorator('line_manager', {
              initialValue: '',
            })(<Input placeholder='Nhập email' />)}
          </Form.Item>
        </Col>
      </Row>
      <Row className='filter-segment'>
        <Col span={24}>
          <Button onClick={handleSearch} icon='search' type='primary'>Tìm kiếm</Button>
          {' '}
          <Button onClick={handleReset} icon='reload'>Reset</Button>
        </Col>
      </Row>
    </Form>
  );
};
export default Form.create({ name: 'form_filter_users' })(FormFilter);
